var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCompareEnabled)?_c('div',[_c('component-form-button-icon',{class:( _obj = {}, _obj[_vm.$style.button] = true, _obj[_vm.$style.buttonActive] = _vm.inCompare, _obj ),attrs:{"title":_vm.inCompare ? 'Удалить из сравнения' : 'Добавить в сравнение',"loading":_vm.isLoading,"icon":_vm.mdiPoll,"size":_vm.size},on:{"click":_vm.addToCompare}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }